export const isWebviewSelector = state =>
  state.publicRuntimeConfig?.pageProperties?.isWebview || false
